module.exports = {
    english: "Angličtina",
    slovak: "Slovenčina",
    deutsch: "Nemčina",
    log_in_via: "Prihlásenie cez",
    log_in_using_local_account: "Prihlásenie pomocou lokálneho účtu",
    per: "za",
    or: "ALEBO",
    user: "Používateľ",
    password: "Heslo",
    device: "Zariadenie",
    status: "Stav",
    action: "Akcia",
    imprint_id: "ID odtlačku",
    name: "Názov",
    brand: "Značka",
    description: "Poznámka",
    timestamp: "Časová značka",
    uptime: "Čas online ",
    firmware_version: "Verzia softvéru",
    appliance_on: "Zapol sa spotrebič",
    appliance_off: "Vypol sa spotrebič",
    identification_success: "Úspešnosť identifikácie",
    duration: "Dĺžka behu",
    energy_consumption: "Spotrebovaná energia",
    minutes: "min",
    and: "a",
    seconds: "s",
    are_you_sure: "Ste si istý?",
    unknown: "Neznáme",
    merito_energy: "Energia MeriTo",
    last_change: "Posledná zmena",
    energy_relay: "Energia",
    in_seconds: "v sekundách",
    test_profile: "Testovací profil",
    relative_error: "Relatívna chyba",
    absolute_error: "Absolútna chyba",
    test_value: "Testovaná veličina",
    no_device: "Žiadne zariadenie",
    showing: "Zobrazené",
    of: "z",
    rows: "riadkov",
    mac_address: "MAC adresa",
    none: "Žiadne",
    static: "Statické",
    detected_on: "Detekované na",
    status_db_update: "Aktualizácia databázy",
    ws_icon_connected: "Pripojené",
    ws_icon_not_connected: "Spojenie vypršalo"
}